import { createRestSlice } from "./restSlice";

export type ReleaseStatus = "pending" | "released" | "failed";

/**
 * Runtime provenance recorded for dedicated (coderunner) releases — the
 * primfunctions version baked into the release's image. `image` is only
 * present for global admins; the API strips it for org users.
 */
export type ReleaseRuntime = {
  primfunctionsVersion?: string;
  image?: string;
  source: "coderunner-build";
  resolvedAt: string;
};

export type Release = {
  id: string;
  organizationId: string;
  agentId: string;
  environmentId: string;
  functionId?: string;
  userId: string;
  status: ReleaseStatus;
  runtime?: ReleaseRuntime;
  createdAt: string;
  updatedAt: string;
  deletedAt: string | null;
};

const releaseSlice = createRestSlice<Release>("release", "/v1/releases");

export const releaseReducer = releaseSlice.reducer;
export const releaseActions = releaseSlice.actions;
